import { AppConfigProvider } from '../../context/app-config-context';
import { LayoutProvider } from '../../context/layout-context';
import Sidebar from '../sidebar';

import PanelLayout from './PanelLayout';

export const LayoutV2: React.FC = () => {
  return (
    <AppConfigProvider>
      <Sidebar />
      <LayoutProvider>
        <PanelLayout />
      </LayoutProvider>
    </AppConfigProvider>
  );
};
